import { render } from "./svg_loader.vue?vue&type=template&id=1fe44f2a"
import script from "./svg_loader.vue?vue&type=script&lang=js"
export * from "./svg_loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__